import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { cloudInfo, startCloud, stopCloud } from "@/lib/cloud";

const Ctx = createContext(null);

export const ROLE_LABEL = { sendco: "SENDCO", head: "Headteacher", staff: "Staff", governor: "Governor" };
export const isManager = (role) => role === "sendco" || role === "head";

export const WorkspaceProvider = ({ children }) => {
  const [ws, setWs] = useState(() => (cloudInfo() ? null : false));

  useEffect(() => {
    if (!cloudInfo()) return undefined;
    let live = true;
    api.get("/rc/me")
      .then(({ data }) => { if (live) setWs(data?.user ? data : false); })
      .catch(() => { if (live) { stopCloud(); setWs(false); } });
    return () => { live = false; };
  }, []);

  useEffect(() => {
    const out = () => {
      stopCloud();
      setWs((cur) => {
        if (cur) toast.info("You've been signed out of the workspace. Please sign in again.");
        return false;
      });
    };
    window.addEventListener("sap:signedout", out);
    return () => window.removeEventListener("sap:signedout", out);
  }, []);

  const signedIn = useCallback(async (data) => {
    await startCloud(data);
    setWs(data);
  }, []);

  const signOut = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch { /* already signed out */ }
    stopCloud();
    setWs(false);
  }, []);

  const refresh = useCallback(async () => {
    const { data } = await api.get("/rc/me");
    setWs(data);
  }, []);

  return <Ctx.Provider value={{ ws, signedIn, signOut, refresh }}>{children}</Ctx.Provider>;
};

export const useWorkspace = () => useContext(Ctx);
